"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleConfigDetail = simpleConfigDetail;
exports.simpleConfigList = simpleConfigList;
exports.simpleConfigSaveOrUpdate = simpleConfigSaveOrUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 简化版系统配置管理 API - 基于 eb_role_switch_whitelist 表

/**
 * 获取配置列表（分页）
 */
function simpleConfigList(params) {
  return (0, _request.default)({
    url: '/api/admin/role/switch/whitelist/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取配置详情
 */
function simpleConfigDetail() {
  return (0, _request.default)({
    url: '/api/admin/role/switch/whitelist/detail',
    method: 'GET'
  });
}

/**
 * 保存或更新配置
 */
function simpleConfigSaveOrUpdate(data) {
  return (0, _request.default)({
    url: '/api/admin/role/switch/whitelist/saveOrUpdate',
    method: 'POST',
    data: data
  });
}